import SectionMixin from '@/mixins/sectionMixin'
import TextWysiwyg from "@/components/global/text-wysiwyg"
import AnchorButton from '@/components/global/anchorButton'

export default {
    name: 'feature-shift-media-block',
    mixins: [SectionMixin],
    components: {
        'text-wysiwyg': TextWysiwyg,
        "anchor-button":AnchorButton
    },
    props: {
        number: String,
        title: String,
        titleBgColor: String,
        description: String,
        mediaBgColor: String,
        videoUrl: String,
        imgUrl: String,
        alternate: Boolean,
        buttonText: String,
        buttonLink: String,
        shift: Boolean,
        fullMedia: Boolean,
        title_question: String,
        text_keyword: String,
        anchor_button: Object,
    },
    data: () => {
        return {
            isIntersecting: false,
            visible: false,
        }
    },
    mounted() {
        console.log('📌 Valor de fullMedia:', this.fullMedia);
        console.log('📦 Todas las props recibidas:', this.$props);
        this.$refs["markdown"].$el.innerHTML = this.convertBackspacesToBr(this.convertStrikethroughToSpan(this.$refs["markdown"].$el.innerHTML))
    },
    beforeDestroy() {

    },
    methods: {
        convertStrikethroughToSpan(text){
            return text.replace(/~~\W|~~\b/m,' <span class="highlight-box">').replace(/(~~)$/gm,'</span> ')
        },
        convertBackspacesToBr(text){
            return text.replace(/\n(?!.)/gm, '<br />');
        },

        show() {
            if (this.visible) {
                return
            }
            this.visible = true
        },
    }
};